<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18MQI8Q/tc-custom/9781504056083.jpg?1698111855681" alt="This image is the cover for the book Rodrigo of Caledon, Rodrigo of Caledon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rodrigo of Caledon, Rodrigo of Caledon
      </h1>
      <p class="bookDescription body article font2">
        <b>An epic medieval fantasy from the John W. Campbell Award–winning author of the Seafort Saga.</b><br/>  <br/><i>The Still</i>: Rodrigo, Prince of Caledon, is petulant, selfish, and uncaring. When his mother, Queen Elena, dies, he fully expects to inherit the title of king. Instead, his uncle usurps the throne, and Rodrigo is forced out of the kingdom, along with his brother and best friend. In order for Rodrigo to take back his birthright, he must win not only the allegiance of the Council of State, but also the Still, a mystical power that can only be channeled by the rightful king of Caledon. To wield that power, Rodrigo must be pure and honest, and must be crowned king. His success or failure will determine the fate of not only his homeland, but of his very soul.<br/>  <br/> “The best fantasy novel of the year.” —<i>Science Fiction Chronicle</i><br/>  <br/><i>The King</i>: Having taken control of the mystical powers of the Still, Rodrigo has gained the knowledge of his forefathers. But even the wisdom of generations of Caledonian rulers can’t prepare him for what will come next. A sudden betrayal costs Rodrigo the life and companionship of the person he loves most. With the savage King Hriskil advancing on the north, hoping to seize Caledon, Rodrigo must press on toward an earth-shattering magical confrontation.<br/>  <br/> “Feintuch’s best book yet.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Feintuch
      </h2>
      
      <p class="authorDescription body article">David Feintuch (1944&ndash;2006) was the author of the award-winning military science fiction Seafort Saga series, which spans <i>Midshipman&rsquo;s Hope, Challenger&rsquo;s Hope, Prisoner&rsquo;s Hope, Fisherman&rsquo;s Hope, Voices of Hope, Patriarch&rsquo;s Hope, </i>and <i>Children of Hope</i>. Feintuch came to writing late, previously having worked as a lawyer and antiques dealer. In 1996, at the age of fifty, he won the John W. Campbell Award for Best New Writer from the World Science Fiction Society. He later expanded into the fantasy genre with his Rodrigo of Caledon series, including <i>The Still</i> and <i>The King</i>.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3aa583ce